/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Demo_CtaInputs */

const en_funnel_ob_demo_cta = /** @type {(inputs: Funnel_Ob_Demo_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Love it, keep going`)
};

const es_funnel_ob_demo_cta = /** @type {(inputs: Funnel_Ob_Demo_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me encanta, sigamos`)
};

/**
* | output |
* | --- |
* | "Love it, keep going" |
*
* @param {Funnel_Ob_Demo_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_demo_cta = /** @type {((inputs?: Funnel_Ob_Demo_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Demo_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_demo_cta(inputs)
	return en_funnel_ob_demo_cta(inputs)
});